export default {"src":"/_next/static/media/client-02.e4be97ef.svg","height":25,"width":70,"blurWidth":0,"blurHeight":0};